import { graphql } from 'react-relay';

export const ScheduleItemFragment = graphql`
    fragment ScheduleItemFragment on ScheduleItem {
        id
        name
        start_datetime
        end_datetime
        status
        color
        type
        bond_left
        bond_right
        bond_parent_ss
        bond_parent_se
        bond_parent_ee
        bond_parent_es
        bond_ss
        bond_se
        bond_ee
        bond_es
        completion_percentage

        cost_code_id
        number_wbs
        project_id
        owner_item_id
        phase_id
        division_id
        description
        parent_id

        children

        role_item
        contract_invoice
        count_hours
        count_days
        count_people
        equipment_hours
        count_tools
        count_material
        material_hours
        priority
        value_equipment
        value_labour
        wo_si
        value_material
        value_other
        value_total
        duration
        start_format_datetime
        end_format_datetime

        assignee
    }
`;
